module.exports = __webpack_public_path__ + "img/Group.c7493519.svg";